module.exports = __webpack_public_path__ + "images/TLC_2025_Radiant_lilac_1440-plus-3x.c394787dfb5f2922402386243d55efaf.png";